import React from "react"
import PaymentForm from "../components/PaymentForm.jsx";

function Payment() {
  return (
    <div>

        <PaymentForm />
      
    </div>
  )
};

export default Payment;